interface INotificationConfig {
  showIcon?: boolean;
  dismissOnTimeout?: boolean;
  dismissButton?: boolean;
  content: string;
  status: string;
}

export interface IAppNotificationDelegate {
  create: (content: string, config?: INotificationConfig) => void;
  error: (content: string, config?: INotificationConfig) => void;
  success: (content: string, config?: INotificationConfig) => void;
  info: (content: string, config?: INotificationConfig) => void;
  content: (header: string, message?: string) => string;
}

export class AppNotificationDelegate implements IAppNotificationDelegate {
  private __appNotification: any;

  constructor(private phxNotificationDelegate: any) {
    this.__appNotification = this.phxNotificationDelegate.restrictTo('app-alerts');
  }

  protected _config(config: INotificationConfig, content: string): INotificationConfig {
    const DEFAULTS: { showIcon: boolean } = {
      showIcon: true
    };

    config = _.merge({}, DEFAULTS, config);

    if (config.status === 'error') {
      config.dismissOnTimeout = false;
    }

    config.content = content;

    return config;
  }

  // create content helper, but we can make it concatenate text (or make it standard)
  // OR [header, content] and we can support an array of text...
  // OR (string, string, string, object) and we collect all strings into one array; does not work well with TypeScript
  // OR (header, body, config) and we expand the contract permanently - Campus always has title/text and we have to split it out
  // OR (config) and you have to load all properties on config and we always merge
  content(header: string, message: string): string {
    return `<h5 class="h5">${header}</h5><p class="text">${message}</p>`;
  }

  create(content: string, config?: INotificationConfig): void {
    this.__appNotification.create(
      this._config(config as INotificationConfig, content),
      (config as INotificationConfig).status
    );
  }

  error(content: string, config?: INotificationConfig): void {
    this.__appNotification.error(this._config({ ...(config as INotificationConfig), status: 'error' }, content));
  }

  success(content: string, config?: INotificationConfig): void {
    this.__appNotification.success(this._config({ ...(config as INotificationConfig), status: 'success' }, content));
  }

  info(content: string, config?: INotificationConfig): void {
    this.__appNotification.info(this._config({ ...(config as INotificationConfig), status: 'info' }, content));
  }
  warn(content: string, config?: INotificationConfig): void {
    this.__appNotification.warn(this._config({ ...(config as INotificationConfig), status: 'warn' }, content));
  }
}



// WEBPACK FOOTER //
// ./app/lib/app_notification_service.ts